import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ReactiveFormsModule, FormControl } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { AutoValidateDirective } from '../../directives/auto-validate.directive';
import { FIELD_CONTROL, FIELD_CONFIG } from './field-tokens';

@Component({
  selector: 'app-field-number',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, InputTextModule, AutoValidateDirective],
  template: `
    <input type="number" pInputText
      [formControl]="formControl"
      [placeholder]="config.placeholder || ''"
      [class]="config.controlClass || 'w-full'"
      appAutoValidate />
  `
})
export class NumberFieldComponent {
  readonly config  = inject(FIELD_CONFIG);
  readonly control = inject(FIELD_CONTROL);
  get formControl(): FormControl { return this.control as FormControl; }
}
